// /* eslint-disable @typescript-eslint/no-unused-vars */
// /* eslint-disable react-hooks/exhaustive-deps */
// import React, { useState, useEffect, useRef, useCallback, useMemo, memo, lazy, Suspense } from "react";
// import {
//   UseFormRegister,
//   FieldErrors,
//   UseFormSetValue,
//   UseFormClearErrors,
//   Control,
//   UseFormWatch,
//   UseFormSetError,
// } from "react-hook-form";
// import SelectInput from "../../../components/Select";
// import FormErrorMessage from "../../../components/common/FormErrorMessage";
// import {
//   OrderFormData,
//   AddressOption,
//   LocationState,
// } from "../../../types/types";
// import {
//   useDistrictFetchData,
// } from "../../../apis/locationApis";
// import { GULF_COUNTRIES, COUNTRY_FIELDS, FIELD_LABELS, parseNominatimResult } from "./GulfMapPicker";

// // Lazy-load the heavy map component so it doesn't block initial render
// const GulfMapPicker = lazy(() => import("./GulfMapPicker"));

// const API_BASE = "https://track-map.gwarm.net/api/areas";

// interface ReceiverAddressProps {
//   register: UseFormRegister<OrderFormData>;
//   setValue: UseFormSetValue<OrderFormData>;
//   watch: UseFormWatch<OrderFormData>;
//   errors: FieldErrors<OrderFormData>;
//   clearErrors: UseFormClearErrors<OrderFormData>;
//   control: Control<OrderFormData>;
//   className?: string;
//   cities: any;
//   handleCitySearch?: (query: string) => void;
//   isCitiesFetchPending?: boolean;
//   selectedOption: AddressOption;
//   setSelectedOption: React.Dispatch<React.SetStateAction<AddressOption>>;
//   countries?: any[];
//   onCountryChange?: (countryId: string) => void;
//   setError: UseFormSetError<OrderFormData>;
//   isSidebar?: boolean;
// }

// // ── Tiny spinner used in multiple places ──────────────────────────────────────
// const Spinner = memo(() => (
//   <svg className="animate-spin h-4 w-4 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//     <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
//     <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"/>
//   </svg>
// ));

// // ── Map loading skeleton ──────────────────────────────────────────────────────
// const MapSkeleton = () => (
//   <div style={{ height: 260, borderRadius: 12, border: "1px solid #e5e7eb", background: "#f3f4f6", display: "flex", alignItems: "center", justifyContent: "center" }}>
//     <span style={{ color: "#9ca3af", fontSize: 13 }}>Loading map…</span>
//   </div>
// );
 
 
// // Stacked helper row for sidebar grid
// const StackedRow = ({ label, required: req, children }: { label: string; required?: boolean; children: React.ReactNode }) => (
//   <div className="flex items-center gap-2">
//     <span className="text-[#1E293B] text-xs whitespace-nowrap">
//       {label}{req && <span className="text-red-500 ml-0.5">*</span>}
//     </span>
//     <div className="w-full">{children}</div>
//   </div>
// );

// const ReceiverAddress: React.FC<ReceiverAddressProps> = ({
//   register,
//   errors,
//   setValue,
//   watch,
//   control,
//   clearErrors,
//   className,
//   cities,
//   handleCitySearch,
//   isCitiesFetchPending,
//   countries = [],
//   onCountryChange,
//   setError,
//   isSidebar = false,
// }) => {
//   const [showMap, setShowMap] = useState(false);

//   // Pin state: what the user clicked/dragged on the map
//   const [pinPosition, setPinPosition] = useState<{ lat: number; lng: number } | null>(null);
//   // Snap state: coordinates returned by DB (zone match) → we move the pin here
//   const [snappedPosition, setSnappedPosition] = useState<{ lat: number; lng: number } | null>(null);

//   // Track whether this is the first pin in current session
//   // "first pin"  → use DB zone result, snap pin, fill address, set source="database_zone"
//   // "second pin" → expect real short address from API; if still zone/not-found → warn
//   const isPinnedRef = useRef(false);

//   const [shortAddressWarning, setShortAddressWarning] = useState<string>("");
//   const [shortAddressLoading, setShortAddressLoading] = useState(false);
//   const [shortAddressError, setShortAddressError] = useState<string>("");
//   const [searchRef, setSearchRef] = useState<string>("");

//   // Derive country code from form value
//   const countryNameWatch = watch("receiver.countryName");
//   const receiverLocationCity = watch("receiver.city");

//   const countryCode = useMemo(
//     () => GULF_COUNTRIES.find(c => c.name.toLowerCase() === countryNameWatch?.toLowerCase())?.code || "OTHER",
//     [countryNameWatch]
//   );

//   const latWatch = watch("receiver.latitude");
//   const lngWatch = watch("receiver.longitude");

//   useEffect(() => {
//     const lat = parseFloat(latWatch || "");
//     const lng = parseFloat(lngWatch || "");
//     if (!isNaN(lat) && !isNaN(lng)) {
//       if (!pinPosition || Math.abs(pinPosition.lat - lat) > 0.00001 || Math.abs(pinPosition.lng - lng) > 0.00001) {
//         const newPos = { lat, lng };
//         setPinPosition(newPos);
//         setSnappedPosition(null);
//       }
//     } else {
//       if (pinPosition !== null && (!latWatch && !lngWatch)) {
//         setPinPosition(null);
//         setSnappedPosition(null);
//       }
//     }
//   }, [latWatch, lngWatch]);

//   const {
//     data: districts = [],
//     isPending: isDistrictFetchPending,
//     refetch: fetchReceiverDistricts,
//   } = useDistrictFetchData(receiverLocationCity, searchRef, "map");

//   const handleDistrictSearch = useCallback((query: string) => {
//     if (query.trim().length >= 3) {
//       setSearchRef(query);
//       fetchReceiverDistricts();
//     }
//   }, [fetchReceiverDistricts]);

//   // ── Apply address fields from API response ────────────────────────────────
//   const applyAddressFromApi = useCallback((addr: any, activeCountryCode: string) => {
//     setValue("receiver.address", `${addr.buildingNumber || ""} ${addr.street || ""} ${addr.district || ""} ${addr.city || ""}`.trim());

//     if (addr.city) {
//       setValue("receiver.cityName", addr.city);
//       const cityData = cities?.find((c: any) => c.name.toLowerCase() === addr.city?.toLowerCase());
//       setValue("receiver.city", cityData?.id ?? null as any);
//       if (cityData) fetchReceiverDistricts();
//     }

//     if (addr.district) {
//       setValue("receiver.districtName", addr.district);
//       const distData = districts?.find((d: any) => d.name.toLowerCase() === addr.district?.toLowerCase());
//       setValue("receiver.district", distData?.id ?? null as any);
//       clearErrors("receiver.district");
//     }

//     setValue("receiver.streetName", addr.street || "");
//     setValue("receiver.buildingNumber", addr.buildingNumber || "");
//     setValue("receiver.zipCode", addr.postalCode || "");
//   }, [cities, districts, setValue, fetchReceiverDistricts]);

//   // ── Map click / drag handler ──────────────────────────────────────────────
//   const handleMapPick = useCallback(async (latLng: { lat: number; lng: number }, mapData: any) => {
//     // ── INSTANT: pin drops exactly where the user clicked, no waiting ─────
//     setPinPosition(latLng);
//     setSnappedPosition(null);
//     setValue("receiver.latitude", latLng.lat.toString());
//     setValue("receiver.longitude", latLng.lng.toString());

//     // Detect country from Nominatim & update dropdown if changed
//     let activeCountryCode = countryCode;
//     const detectedCode = mapData?.address?.country_code?.toUpperCase();
//     if (detectedCode && detectedCode !== countryCode && GULF_COUNTRIES.some(c => c.code === detectedCode)) {
//       activeCountryCode = detectedCode;
//       const gulfName = GULF_COUNTRIES.find(c => c.code === detectedCode)?.name || "";
//       const matched = countries.find((c: any) => c.name.toLowerCase() === gulfName.toLowerCase());
//       if (matched && onCountryChange) onCountryChange(matched.id);
//     }

//     if (activeCountryCode === "SA") {
//       setShortAddressLoading(true);
//       setShortAddressError("");
//       setShortAddressWarning("");
//       setValue("receiver.shortAddress", "");
//       setValue("receiver.nationalAddress", "");
//       clearErrors("receiver.shortAddress");
//       clearErrors("receiver.nationalAddress");

//       // 1. Check if google map (Nominatim) data contains short address
//       let foundShortAddress: string | null = null;
//       if (mapData) {
//         const textToSearch = JSON.stringify(mapData);
//         const match = textToSearch.match(/\b([a-zA-Z]{4}\d{4})\b/);
//         if (match) {
//           foundShortAddress = match[1].toUpperCase();
//         }
//       }

//       if (foundShortAddress) {
//         setValue("receiver.shortAddress", foundShortAddress);
//         setValue("receiver.nationalAddress", foundShortAddress);

//         try {
//           const checkRes = await fetch(`${API_BASE}/adrress-get-by-short-address?shortAddress=${foundShortAddress}`);
//           const checkData = await checkRes.json();
//           if (checkData?.success && checkData?.data) {
//             const shortAddr = checkData.data;
//             applyAddressFromApi(shortAddr, activeCountryCode);

//             if (shortAddr.latitude && shortAddr.longitude) {
//               const pos = { lat: parseFloat(shortAddr.latitude), lng: parseFloat(shortAddr.longitude) };
//               setPinPosition(pos);
//               setSnappedPosition(pos);
//               setValue("receiver.latitude", shortAddr.latitude.toString());
//               setValue("receiver.longitude", shortAddr.longitude.toString());
//             }
//             setShortAddressWarning("");
//             setShortAddressError("");
//           } else {
//             setShortAddressError("Short Address verified lookup failed. Please type it manually.");
//           }
//         } catch (err) {
//           console.error("Short address verification lookup failed:", err);
//           setShortAddressError("Could not verify short address. Please try again.");
//         } finally {
//           setShortAddressLoading(false);
//         }
//         isPinnedRef.current = true;
//         return;
//       }

//       // 2. Check coordinates API
//       try {
//         const res = await fetch(`${API_BASE}/find-by-coordinates?lat=${latLng.lat}&lon=${latLng.lng}`);
//         const apiData = await res.json();

//         if (apiData?.success && apiData?.data) {
//           const addr = apiData.data;
//           const source: string = addr.source ?? "database";
//           applyAddressFromApi(addr, activeCountryCode);

//           if (source === "redis_geo" || source === "database_zone") {
//             if (addr.latitude && addr.longitude) {
//               const snapped = { lat: parseFloat(addr.latitude), lng: parseFloat(addr.longitude) };
//               setSnappedPosition(snapped);
//               setPinPosition(snapped);
//               setValue("receiver.latitude", addr.latitude.toString());
//               setValue("receiver.longitude", addr.longitude.toString());
//             }
//           }

//           const resolvedShortCode = addr.name;
//           if (resolvedShortCode) {
//             setValue("receiver.shortAddress", resolvedShortCode);
//             setValue("receiver.nationalAddress", resolvedShortCode);

//             try {
//               const checkRes = await fetch(`${API_BASE}/adrress-get-by-short-address?shortAddress=${resolvedShortCode}`);
//               const checkData = await checkRes.json();
//               if (checkData?.success && checkData?.data) {
//                 const shortAddr = checkData.data;
//                 applyAddressFromApi(shortAddr, activeCountryCode);

//                 if (shortAddr.latitude && shortAddr.longitude) {
//                   const pos = { lat: parseFloat(shortAddr.latitude), lng: parseFloat(shortAddr.longitude) };
//                   setPinPosition(pos);
//                   setSnappedPosition(pos);
//                   setValue("receiver.latitude", shortAddr.latitude.toString());
//                   setValue("receiver.longitude", shortAddr.longitude.toString());
//                 }

//                 if (source === "database_zone") {
//                   setShortAddressWarning("📍 Approximate match. Pin again on the exact spot for precise short address.");
//                 } else {
//                   setShortAddressWarning("");
//                 }
//                 setShortAddressError("");
//               } else {
//                 setShortAddressError("Short Address verified lookup failed. Please type it manually.");
//               }
//             } catch (err) {
//               console.error("Short address verification lookup failed:", err);
//               setShortAddressError("Could not verify short address. Please try again.");
//             }
//           } else {
//             setValue("receiver.shortAddress", "");
//             setValue("receiver.nationalAddress", "");
//             setShortAddressError("Short Address was not found from the map. Please fill it manually.");
//           }

//           isPinnedRef.current = true;
//           setShortAddressLoading(false);
//           return;
//         }
//       } catch (err) {
//         console.error("find-by-coordinates failed:", err);
//       }

//       // 3. Fallback: geocoding but no short address found
//       setShortAddressLoading(false);
//       setValue("receiver.shortAddress", "");
//       setValue("receiver.nationalAddress", "");
//       setShortAddressWarning("");
//       setShortAddressError("Short Address was not found from the map. Please fill it manually.");
//     }

//     const parsed: any = parseNominatimResult(mapData, activeCountryCode);
//     setValue("receiver.address", parsed.fullAddress || "");

//     if (parsed.city) {
//       setValue("receiver.cityName", parsed.city);
//       const cityData = cities?.find((c: any) => c.name.toLowerCase() === parsed.city.toLowerCase());
//       setValue("receiver.city", cityData?.id ?? null as any);
//       if (cityData) fetchReceiverDistricts();
//     }

//     const districtEquivalent = parsed.district || parsed.area || parsed.zone || parsed.block || parsed.wilayat;
//     if (districtEquivalent) {
//       setValue("receiver.districtName", districtEquivalent);
//       const distData = districts?.find((d: any) => d.name.toLowerCase() === districtEquivalent.toLowerCase());
//       setValue("receiver.district", distData?.id ?? null as any);
//       clearErrors("receiver.district");
//     }

//     setValue("receiver.streetName", parsed.street || "");
//     setValue("receiver.buildingNumber", parsed.building || "");
//     setValue("receiver.zipCode", parsed.postalCode || parsed.poBox || "");

//     if (activeCountryCode !== "SA" && parsed.shortAddress) {
//       setValue("receiver.shortAddress", parsed.shortAddress);
//       setValue("receiver.nationalAddress", parsed.shortAddress);
//     }

//     isPinnedRef.current = true;
//   }, [countryCode, countries, onCountryChange, setValue, applyAddressFromApi, cities, districts, fetchReceiverDistricts, clearErrors]);

//   // ── Short address manual input ────────────────────────────────────────────
//   const handleShortAddressChange = useCallback(async (e: React.ChangeEvent<HTMLInputElement>) => {
//     const val = e.target.value.toUpperCase();
//     setValue("receiver.shortAddress", val);
//     setValue("receiver.nationalAddress", val);
//     setShortAddressWarning("");
//     setShortAddressError("");
//     clearErrors("receiver.shortAddress");
//     clearErrors("receiver.nationalAddress");

//     if (val.length === 8) {
//       setShortAddressLoading(true);
//       try {
//         const res = await fetch(`${API_BASE}/adrress-get-by-short-address?shortAddress=${val}`);
//         const apiData = await res.json();
//         if (apiData?.success && apiData?.data) {
//           const addr = apiData.data;
//           setShortAddressError("");
//           applyAddressFromApi(addr, countryCode);

//           if (addr.latitude && addr.longitude) {
//             const pos = { lat: parseFloat(addr.latitude), lng: parseFloat(addr.longitude) };
//             setPinPosition(pos);
//             setSnappedPosition(pos);
//             setValue("receiver.latitude", addr.latitude.toString());
//             setValue("receiver.longitude", addr.longitude.toString());
//           }
//           clearErrors("receiver.shortAddress");
//           clearErrors("receiver.nationalAddress");
//         } else {
//           setShortAddressError("Short code not found. Please check and enter a correct code.");
//         }
//       } catch (err) {
//         console.error("Short address lookup failed:", err);
//         setShortAddressError("Could not verify short address. Please try again.");
//       } finally {
//         setShortAddressLoading(false);
//       }
//     } else if (val.length === 0) {
//       setPinPosition(null);
//       setSnappedPosition(null);
//     }
//   }, [setValue, countryCode, applyAddressFromApi, clearErrors]);

//   // Reset pin tracking when map is re-opened
//   const handleToggleMap = useCallback(() => {
//     setShowMap(prev => {
//       if (!prev) isPinnedRef.current = false; // fresh open → reset
//       return !prev;
//     });
//   }, []);

//   const fieldKeys: string[] = useMemo(() => COUNTRY_FIELDS[countryCode] || COUNTRY_FIELDS["SA"], [countryCode]);

//   const isPinned = !!pinPosition;
//   const shortAddressVal = watch("receiver.shortAddress");
//   const shortAddressOk = !shortAddressLoading && !shortAddressError && shortAddressVal?.length === 8 && watch("receiver.address");



//   const compactInputCls = (hasErr?: boolean) =>
//     `w-full text-sm rounded-lg border px-3 py-1.5 outline-none focus:border-[#FBD037] focus:ring-1 focus:ring-[#FBD037]/30 transition-all ${hasErr ? "border-red-400 bg-red-50" : "border-gray-200 bg-white"}`;

//   const gridFields = useMemo(() => {
//     if (countryCode === "SA") {
//       return ["shortAddress", "city", "district", "street", "latitude", "longitude", "building", "postalCode"];
//     } else {
//       const keys = fieldKeys.filter(k => k !== "shortAddress");
//       const first4 = keys.slice(0, 4);
//       const remaining = keys.slice(4);
//       return [...first4, "latitude", "longitude", ...remaining];
//     }
//   }, [countryCode, fieldKeys]);

//   const renderField = (key: string) => {
//     if (key === "shortAddress") {
//       return (
//         <StackedRow key={key} label="Short Add" required={countryCode === "SA"}>
//           <div className="relative">
//             <input
//               {...(() => {
//                 const { onChange: formOnChange, ...rest } = register("receiver.shortAddress", {
//                   required: countryCode === "SA" ? "Short address is required" : false,
//                   validate: (val) => {
//                     if (countryCode === "SA" && val && val.length !== 8) {
//                       return "Short address must be 8 characters";
//                     }
//                     return true;
//                   }
//                 });
//                 return { ...rest, onChange: (e: any) => { formOnChange(e); handleShortAddressChange(e); } };
//               })()}
//               placeholder="e.g. RHOO2375"
//               autoComplete="off"
//               disabled={shortAddressLoading}
//               className={`w-full text-sm rounded-lg border px-3 py-1.5 outline-none pr-8 transition-all focus:border-[#FBD037] ${
//                 shortAddressLoading ? "border-blue-300 bg-blue-50" : (shortAddressError || errors.receiver?.shortAddress) ? "border-red-400 bg-red-50" : shortAddressWarning ? "border-yellow-400 bg-white" : "border-gray-200 bg-white"
//               }`}
//             />
//             <div className="absolute inset-y-0 right-2 flex items-center">
//               {shortAddressLoading && <Spinner />}
//               {!shortAddressLoading && (shortAddressError || errors.receiver?.shortAddress) && <span className="text-red-500 text-sm">✕</span>}
//               {shortAddressOk && <span className="text-green-500 text-sm">✓</span>}
//             </div>
//           </div>
//           {shortAddressError && !shortAddressLoading && <p className="text-[10px] text-red-500 mt-0.5">⚠ {shortAddressError}</p>}
//           {errors.receiver?.shortAddress && !shortAddressError && !shortAddressLoading && (
//             <p className="text-[10px] text-red-500 mt-0.5">⚠ {errors.receiver?.shortAddress?.message}</p>
//           )}
//           {shortAddressWarning && !shortAddressError && !errors.receiver?.shortAddress && !shortAddressLoading && <p className="text-[10px] text-yellow-600 mt-0.5">{shortAddressWarning}</p>}
//         </StackedRow>
//       );
//     }

//     const isCity = key === "city";
//     const isDistrict = ["district", "area", "zone", "block", "wilayat", "governorate"].includes(key);
//     let rhfName: any = `receiver.${key}`;
//     if (key === "street" || key === "road") rhfName = "receiver.streetName";
//     if (key === "building") rhfName = "receiver.buildingNumber";
//     if (key === "poBox" || key === "postalCode") rhfName = "receiver.zipCode";
//     const isRequiredField = key !== "region" && key !== "poBox" && (countryCode === "SA" || (key !== "street" && key !== "building"));
//     const fieldKey = rhfName.replace(/^receiver\./, "");
//     const fieldError = (errors.receiver as any)?.[fieldKey];

//     if (isCity) return (
//       <StackedRow key={key} label={FIELD_LABELS[key]?.label || "City / Town"} required>
//         <SelectInput name="receiver.city" label="" placeholder={FIELD_LABELS[key]?.placeholder}
//           selectOptions={cities?.map((c: any) => ({ id: c.id, value: c.id, text: c.name })) || []}
//           value={watch("receiver.city") || watch("receiver.cityName")}
//           setValue={(val) => {
//             const m = cities?.find((c: any) => c.id === val);
//             if (m) {
//               setValue("receiver.city", m.id);
//               setValue("receiver.cityName", m.name);
//             } else {
//               setValue("receiver.city", null as any);
//               setValue("receiver.cityName", val);
//             }
//           }}
//           onSearch={handleCitySearch} isPending={isCitiesFetchPending} register={register}
//           validation={{ required: "City is required" }} error={errors.receiver?.city} clearErrors={clearErrors} allowCustom={true} />
//       </StackedRow>
//     );

//     if (isDistrict) return (
//       <StackedRow key={key} label={FIELD_LABELS[key]?.label || "District"} required>
//         <SelectInput name="receiver.district" label="" placeholder={FIELD_LABELS[key]?.placeholder}
//           selectOptions={districts?.map((d: any) => ({ id: d.id, value: d.id, text: d.name })) || []}
//           value={watch("receiver.district") || watch("receiver.districtName")}
//           setValue={(val) => {
//             const m = districts?.find((d: any) => d.id === val);
//             if (m) {
//               setValue("receiver.district", m.id);
//               setValue("receiver.districtName", m.name);
//             } else {
//               setValue("receiver.district", null as any);
//               setValue("receiver.districtName", val);
//             }
//           }}
//           onSearch={handleDistrictSearch} isPending={isDistrictFetchPending} register={register} clearErrors={clearErrors}
//           validation={{ validate: (val) => { const dn = watch("receiver.districtName"); return (!val && !dn) ? `${FIELD_LABELS[key]?.label || "District"} is required` : true; } }}
//           error={errors.receiver?.district} allowCustom={true} />
//       </StackedRow>
//     );

//     const fieldValidation = rhfName === "receiver.zipCode"
//       ? (countryCode === "SA" ? { required: "Zip code is required", pattern: { value: /^\d+$/, message: "Digits only" } } : undefined)
//       : isRequiredField ? { required: `${FIELD_LABELS[key]?.label || "This field"} is required` } : undefined;

//     return (
//       <StackedRow key={key} label={FIELD_LABELS[key]?.label || key} required={isRequiredField}>
//         <input {...register(rhfName, fieldValidation)} placeholder={FIELD_LABELS[key]?.placeholder}
//           className={compactInputCls(!!fieldError)} />
//         {fieldError && <FormErrorMessage error={fieldError} />}
//       </StackedRow>
//     );
//   };

//   if (isSidebar) {
//     return (
//       <div className="w-full mt-1 space-y-3">
//         {/* Map toggle compact */}
//         <div className="flex items-center justify-between py-1.5 border-b border-slate-100">
//           {/* <span className="text-xs font-semibold text-slate-500 uppercase tracking-wide flex items-center gap-1.5">
//             Map {isPinned && <span className="px-1.5 py-0.5 rounded-full bg-green-100 text-green-700 text-[10px] font-bold">📍 Pinned</span>}
//           </span> */}
//           <button type="button" onClick={handleToggleMap}
//             className="px-2.5 py-1 rounded-md bg-[#4F6EF7] text-white text-xs font-semibold hover:bg-[#3d59c9] transition-colors">
//             {showMap ? "Hide Map" : "Open Map"}
//           </button>
//         </div>

//         {showMap && (
//           <div className="py-2 border-b border-slate-100">
//             <Suspense fallback={<MapSkeleton />}>
//               <GulfMapPicker country={countryCode} onPick={handleMapPick} pinPosition={pinPosition} snappedPosition={snappedPosition} />
//             </Suspense>
//           </div>
//         )}

//         {/* Grid for small fields */}
//         <div className="grid grid-cols-2 gap-3 relative z-10">
//           {gridFields.map((key) => {
//             if (key === "latitude") {
//               return (
//                 <StackedRow key="latitude" label="Latitude" required={countryCode === "SA"}>
//                   <input {...register("receiver.latitude", countryCode === "SA" ? { required: "Required" } : undefined)}
//                     placeholder="e.g. 24.7136" className={compactInputCls(!!errors.receiver?.latitude)} />
//                   <FormErrorMessage error={errors.receiver?.latitude} />
//                 </StackedRow>
//               );
//             }
//             if (key === "longitude") {
//               return (
//                 <StackedRow key="longitude" label="Longitude" required={countryCode === "SA"}>
//                   <input {...register("receiver.longitude", countryCode === "SA" ? { required: "Required" } : undefined)}
//                     placeholder="e.g. 46.6753" className={compactInputCls(!!errors.receiver?.longitude)} />
//                   <FormErrorMessage error={errors.receiver?.longitude} />
//                 </StackedRow>
//               );
//             }
//             return renderField(key);
//           })}
//         </div>

//         {/* Full Address - large field, full width */}
//         <StackedRow label="Full Address" required>
//           <input
//             {...register("receiver.address", { required: "Full address is required" })}
//             placeholder="Enter full address"
//             className={compactInputCls(!!errors.receiver?.address)}
//             disabled
//           />
//           <FormErrorMessage error={errors.receiver?.address} />
//         </StackedRow>
//       </div>
//     );
//   }

//   // ── Non-sidebar: original card layout ──
//   return (
//     <div className={`bg-[#fdfdf6] rounded-xl space-y-6 mt-2 p-4 border w-full ${className}`}>
//       <div className="space-y-4">

//         {/* Map Toggle */}
//         <div className="flex justify-between items-center w-full">
//           <label className="text-sm font-medium text-gray-700 flex items-center gap-2">
//             Pin Location on Map
//             {isPinned && <span className="px-2 py-0.5 rounded-full bg-green-100 text-green-700 text-xs font-bold">📍 Pinned</span>}
//           </label>
//           <button
//             type="button"
//             onClick={handleToggleMap}
//             className="px-3 py-1.5 rounded-md bg-[#4F6EF7] text-white text-xs font-semibold hover:bg-[#3d59c9] transition-colors"
//           >
//             {showMap ? "Hide Map" : "Open Map"}
//           </button>
//         </div>

//         {/* The Map — lazy loaded */}
//         {showMap && (
//           <Suspense fallback={<MapSkeleton />}>
//             <GulfMapPicker
//               country={countryCode}
//               onPick={handleMapPick}
//               pinPosition={pinPosition}
//               snappedPosition={snappedPosition}
//             />
//           </Suspense>
//         )}

//         {/* Short Address & Full Address */}
//         {countryCode === "SA" ? (
//           <div className={`flex gap-4 w-full ${isSidebar ? "flex-col" : "flex-row"}`}>
//             <div className={`relative ${isSidebar ? "w-full" : "w-[30%]"}`}>
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Short Add / National Address <span className="text-red-500">*</span>
//               </label>
//               <div className="relative">
//                 <input
//                   {...(() => {
//                     const { onChange: formOnChange, ...rest } = register("receiver.shortAddress", {
//                       required: countryCode === "SA" ? "Short address is required" : false,
//                       validate: (val) => {
//                         if (countryCode === "SA" && val && val.length !== 8) {
//                           return "Short address must be 8 characters";
//                         }
//                         return true;
//                       }
//                     });
//                     return {
//                       ...rest,
//                       onChange: (e: any) => {
//                         formOnChange(e);
//                         handleShortAddressChange(e);
//                       }
//                     };
//                   })()}
//                   placeholder="e.g. RHOO2375"
//                   autoComplete="off"
//                   disabled={shortAddressLoading}
//                   className={`w-full rounded-lg py-2 px-3 border outline-none pr-9 transition-all
//                     ${
//                       shortAddressLoading ? "border-blue-300 bg-blue-50" :
//                       shortAddressError ? "border-red-400 bg-red-50" :
//                       shortAddressWarning ? "border-yellow-500 bg-white" :
//                       "border-gray-300 bg-white"
//                     } focus:border-[#FBD037]`}
//                 />
//                 <div className="absolute inset-y-0 right-2 flex items-center">
//                   {shortAddressLoading && <Spinner />}
//                   {!shortAddressLoading && shortAddressError && <span className="text-red-500 text-base">✕</span>}
//                   {shortAddressOk && <span className="text-green-500 text-base">✓</span>}
//                 </div>
//               </div>
//               {shortAddressLoading && (
//                 <div className="mt-1 flex items-center gap-1.5">
//                   <div className="h-2 w-2 rounded-full bg-blue-400 animate-bounce" style={{animationDelay: '0ms'}}/>
//                   <div className="h-2 w-2 rounded-full bg-blue-400 animate-bounce" style={{animationDelay: '150ms'}}/>
//                   <div className="h-2 w-2 rounded-full bg-blue-400 animate-bounce" style={{animationDelay: '300ms'}}/>
//                   <span className="text-xs text-blue-500 font-medium">Looking up address…</span>
//                 </div>
//               )}
//               {shortAddressError && !shortAddressLoading && (
//                 <FormErrorMessage error={{ message: `⚠ ${shortAddressError}` }} />
//               )}
//               {errors.receiver?.shortAddress && !shortAddressError && !shortAddressLoading && (
//                 <FormErrorMessage error={errors.receiver?.shortAddress} />
//               )}
//               {shortAddressWarning && !shortAddressError && !shortAddressLoading && (
//                 <span className="text-xs text-yellow-600 mt-1 block font-medium">{shortAddressWarning}</span>
//               )}
//             </div>
//             <div className={isSidebar ? "w-full" : "w-[70%]"}>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Full Address Line <span className="text-red-500">*</span></label>
//               <input
//                 {...register("receiver.address", { required: "Full address is required" })}
//                 placeholder="Enter full address details"
//                 className={`w-full rounded-lg py-2 px-3 border outline-none ${
//                   errors.receiver?.address ? "border-red-500" : "border-gray-300"
//                 } focus:border-[#FBD037]`}
//               />
//               <FormErrorMessage error={errors.receiver?.address} />
//             </div>
//           </div>
//         ) : (
//           <div className="w-full">
//             <label className="block text-sm font-medium text-gray-700 mb-1">Full Address Line <span className="text-red-500">*</span></label>
//             <input
//               {...register("receiver.address", { required: "Full address is required" })}
//               placeholder="Enter full address details"
//               className={`w-full rounded-lg py-2 px-3 border outline-none ${
//                 errors.receiver?.address ? "border-red-500" : "border-gray-300"
//               } focus:border-[#FBD037]`}
//             />
//             <FormErrorMessage error={errors.receiver?.address} />
//           </div>
//         )}

//         {/* Latitude & Longitude */}
//         <div className={`grid gap-4 ${isSidebar ? "grid-cols-1" : "grid-cols-2"}`}>
//           <div className="col-span-1">
//             <label className="block text-sm font-medium text-gray-700 mb-1">Latitude <span className="text-red-500">*</span></label>
//             <input
//               {...register("receiver.latitude", countryCode === "SA" ? { required: "Latitude is required" } : undefined)}
//               placeholder="e.g. 24.7136"
//               className={`w-full rounded-lg py-2 px-3 border outline-none ${
//                 errors.receiver?.latitude ? "border-red-500" : "border-gray-300"
//               } focus:border-[#FBD037]`}
//             />
//             <FormErrorMessage error={errors.receiver?.latitude} />
//           </div>
//           <div className="col-span-1">
//             <label className="block text-sm font-medium text-gray-700 mb-1">Longitude <span className="text-red-500">*</span></label>
//             <input
//               {...register("receiver.longitude", countryCode === "SA" ? { required: "Longitude is required" } : undefined)}
//               placeholder="e.g. 46.6753"
//               className={`w-full rounded-lg py-2 px-3 border outline-none ${
//                 errors.receiver?.longitude ? "border-red-500" : "border-gray-300"
//               } focus:border-[#FBD037]`}
//             />
//             <FormErrorMessage error={errors.receiver?.longitude} />
//           </div>
//         </div>

//         {/* Dynamic Fields */}
//         <div className={`grid gap-4 ${isSidebar ? "grid-cols-1" : "grid-cols-2"}`}>
//           {fieldKeys.filter(k => k !== "shortAddress").map((key) => {
//             const isCity = key === "city";
//             const isDistrict = ["district", "area", "zone", "block", "wilayat"].includes(key);

//             if (isCity) {
//               return (
//                 <div key={key} className="col-span-1">
//                   <SelectInput
//                     name="receiver.city"
//                     label={FIELD_LABELS[key]?.label}
//                     placeholder={FIELD_LABELS[key]?.placeholder}
//                     selectOptions={cities?.map((c: any) => ({
//                       id: c.id,
//                       value: c.id,
//                       text: c.name,
//                     })) || []}
//                     value={watch("receiver.city") || watch("receiver.cityName")}
//                     setValue={(val) => {
//                       const matched = cities?.find((c: any) => c.id === val);
//                       if (matched) {
//                         setValue("receiver.city", matched.id);
//                         setValue("receiver.cityName", matched.name);
//                       } else {
//                         setValue("receiver.city", null as any);
//                         setValue("receiver.cityName", val);
//                       }
//                     }}
//                     onSearch={handleCitySearch}
//                     isPending={isCitiesFetchPending}
//                     register={register}
//                     validation={{ required: "City is required" }}
//                     error={errors.receiver?.city}
//                     clearErrors={clearErrors}
//                     allowCustom={true}
//                   />
//                 </div>
//               );
//             }

//             if (isDistrict) {
//               return (
//                 <div key={key} className="col-span-1">
//                   <SelectInput
//                     name="receiver.district"
//                     label={FIELD_LABELS[key]?.label}
//                     placeholder={FIELD_LABELS[key]?.placeholder}
//                     selectOptions={districts?.map((d: any) => ({
//                       id: d.id,
//                       value: d.id,
//                       text: d.name,
//                     })) || []}
//                     value={watch("receiver.district") || watch("receiver.districtName")}
//                     setValue={(val) => {
//                       const matched = districts?.find((d: any) => d.id === val);
//                       if (matched) {
//                         setValue("receiver.district", matched.id);
//                         setValue("receiver.districtName", matched.name);
//                       } else {
//                         setValue("receiver.district", null as any);
//                         setValue("receiver.districtName", val);
//                       }
//                     }}
//                     onSearch={handleDistrictSearch}
//                     isPending={isDistrictFetchPending}
//                     register={register}
//                     clearErrors={clearErrors}
//                     validation={{
//                       validate: (val) => {
//                         const districtName = watch("receiver.districtName");
//                         if (!val && !districtName) {
//                           return `${FIELD_LABELS[key]?.label || "District"} is required`;
//                         }
//                         return true;
//                       }
//                     }}
//                     error={errors.receiver?.district}
//                     allowCustom={true}
//                   />
//                 </div>
//               );
//             }

//             // Other dynamic fields
//             let rhfName: any = `receiver.${key}`;
//             if (key === "street" || key === "road") rhfName = "receiver.streetName";
//             if (key === "building") rhfName = "receiver.buildingNumber";
//             if (key === "poBox" || key === "postalCode") rhfName = "receiver.zipCode";

//             const isRequiredField = key !== "region" && key !== "poBox" && (countryCode === "SA" || (key !== "street" && key !== "building"));
//             const fieldValidation = rhfName === "receiver.zipCode"
//               ? (countryCode === "SA"
//                 ? {
//                     required: "Zip code is required",
//                     pattern: {
//                       value: /^\d+$/,
//                       message: "Zip code must contain only digits",
//                     },
//                   }
//                 : undefined
//               )
//               : isRequiredField
//               ? { required: `${FIELD_LABELS[key]?.label || "This field"} is required` }
//               : undefined;

//             const fieldKey = rhfName.replace(/^receiver\./, "");
//             const fieldError = (errors.receiver as any)?.[fieldKey];

//             return (
//               <div key={key} className="col-span-1">
//                 <label className="block text-sm font-medium text-gray-700 mb-1">{FIELD_LABELS[key]?.label}</label>
//                 <input
//                   {...register(rhfName, fieldValidation)}
//                   placeholder={FIELD_LABELS[key]?.placeholder}
//                   className={`w-full rounded-lg py-2 px-3 border outline-none focus:border-[#FBD037] ${
//                     fieldError ? "border-red-500" : "border-gray-300"
//                   }`}
//                 />
//                 {fieldError && <FormErrorMessage error={fieldError} />}
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default memo(ReceiverAddress);




/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useCallback, useMemo, memo, lazy, Suspense } from "react";
import {
  UseFormRegister,
  FieldErrors,
  UseFormSetValue,
  UseFormClearErrors,
  Control,
  UseFormWatch,
  UseFormSetError,
} from "react-hook-form";
import SelectInput from "../../../components/Select";
import FormErrorMessage from "../../../components/common/FormErrorMessage";
import {
  OrderFormData,
  AddressOption,
  LocationState,
} from "../../../types/types";
import {
  useDistrictFetchData,
} from "../../../apis/locationApis";
import { GULF_COUNTRIES, COUNTRY_FIELDS, FIELD_LABELS, parseNominatimResult } from "./GulfMapPicker";
import { useLanguage } from "../../../context/LanguageContext";

// Lazy-load the heavy map component so it doesn't block initial render
const GulfMapPicker = lazy(() => import("./GulfMapPicker"));

const API_BASE = "https://track-map.gwarm.net/api/areas";

interface ReceiverAddressProps {
  register: UseFormRegister<OrderFormData>;
  setValue: UseFormSetValue<OrderFormData>;
  watch: UseFormWatch<OrderFormData>;
  errors: FieldErrors<OrderFormData>;
  clearErrors: UseFormClearErrors<OrderFormData>;
  control: Control<OrderFormData>;
  className?: string;
  cities: any;
  handleCitySearch?: (query: string) => void;
  isCitiesFetchPending?: boolean;
  selectedOption: AddressOption;
  setSelectedOption: React.Dispatch<React.SetStateAction<AddressOption>>;
  countries?: any[];
  onCountryChange?: (countryId: string) => void;
  setError: UseFormSetError<OrderFormData>;
  isSidebar?: boolean;
}

// ── Tiny spinner used in multiple places ──────────────────────────────────────
const Spinner = memo(() => (
  <svg className="animate-spin h-4 w-4 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"/>
  </svg>
));

// ── Map loading skeleton ──────────────────────────────────────────────────────
const MapSkeleton = () => {
  const { t } = useLanguage();
  return (
    <div style={{ height: 260, borderRadius: 12, border: "1px solid #e5e7eb", background: "#f3f4f6", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <span style={{ color: "#9ca3af", fontSize: 13 }}>{t("Loading map…")}</span>
    </div>
  );
};
 
 
const StackedRow = ({ label, required: req, children, fullWidth = false }: { label: string; required?: boolean; children: React.ReactNode; fullWidth?: boolean }) => (
  <div className="space-y-1 w-full">
   <span className={`text-[#1E293B] text-xs leading-tight shrink-0 pt-2 whitespace-normal break-words ${fullWidth ? "w-[17.5%]" : "w-[35%]"}`}>
      {label}{req && <span className="text-red-500 ml-0.5">*</span>}
    </span>
    <div className="w-full">{children}</div>
  </div>
);

const ReceiverAddress: React.FC<ReceiverAddressProps> = ({
  register,
  errors,
  setValue,
  watch,
  control,
  clearErrors,
  className,
  cities,
  handleCitySearch,
  isCitiesFetchPending,
  countries = [],
  onCountryChange,
  setError,
  isSidebar = false,
}) => {
  const { t } = useLanguage();
  const [showMap, setShowMap] = useState(false);
  const [isShortAddressLocked, setIsShortAddressLocked] = useState(false); // NEW

  // Pin state: what the user clicked/dragged on the map
  const [pinPosition, setPinPosition] = useState<{ lat: number; lng: number } | null>(null);
  // Snap state: coordinates returned by DB (zone match) → we move the pin here
  const [snappedPosition, setSnappedPosition] = useState<{ lat: number; lng: number } | null>(null);

  // Track whether this is the first pin in current session
  // "first pin"  → use DB zone result, snap pin, fill address, set source="database_zone"
  // "second pin" → expect real short address from API; if still zone/not-found → warn
  const isPinnedRef = useRef(false);

  const [shortAddressWarning, setShortAddressWarning] = useState<string>("");
  const [shortAddressLoading, setShortAddressLoading] = useState(false);
  const [shortAddressError, setShortAddressError] = useState<string>("");
  const [searchRef, setSearchRef] = useState<string>("");

  // Derive country code from form value
  const countryNameWatch = watch("receiver.countryName");
  const receiverLocationCity = watch("receiver.city");

  const countryCode = useMemo(
    () => GULF_COUNTRIES.find(c => c.name.toLowerCase() === countryNameWatch?.toLowerCase())?.code || "OTHER",
    [countryNameWatch]
  );

  const latWatch = watch("receiver.latitude");
  const lngWatch = watch("receiver.longitude");

  useEffect(() => {
    const lat = parseFloat(latWatch || "");
    const lng = parseFloat(lngWatch || "");
    if (!isNaN(lat) && !isNaN(lng)) {
      if (!pinPosition || Math.abs(pinPosition.lat - lat) > 0.00001 || Math.abs(pinPosition.lng - lng) > 0.00001) {
        const newPos = { lat, lng };
        setPinPosition(newPos);
        setSnappedPosition(null);
      }
    } else {
      if (pinPosition !== null && (!latWatch && !lngWatch)) {
        setPinPosition(null);
        setSnappedPosition(null);
      }
    }
  }, [latWatch, lngWatch]);

  const {
    data: districts = [],
    isPending: isDistrictFetchPending,
    refetch: fetchReceiverDistricts,
  } = useDistrictFetchData(receiverLocationCity, searchRef, "map");

  const handleDistrictSearch = useCallback((query: string) => {
    if (query.trim().length >= 3) {
      setSearchRef(query);
      fetchReceiverDistricts();
    }
  }, [fetchReceiverDistricts]);

  // ── Apply address fields from API response ────────────────────────────────
  const applyAddressFromApi = useCallback((addr: any, activeCountryCode: string) => {
    setValue("receiver.address", `${addr.buildingNumber || ""} ${addr.street || ""} ${addr.district || ""} ${addr.city || ""}`.trim());

    if (addr.city) {
      setValue("receiver.cityName", addr.city);
      const cityData = cities?.find((c: any) => c.name.toLowerCase() === addr.city?.toLowerCase());
      setValue("receiver.city", cityData?.id ?? null as any);
      if (cityData) fetchReceiverDistricts();
    }

    if (addr.district) {
      setValue("receiver.districtName", addr.district);
      const distData = districts?.find((d: any) => d.name.toLowerCase() === addr.district?.toLowerCase());
      setValue("receiver.district", distData?.id ?? null as any);
      clearErrors("receiver.district");
    }

    setValue("receiver.streetName", addr.street || "");
    setValue("receiver.buildingNumber", addr.buildingNumber || "");
    setValue("receiver.zipCode", addr.postalCode || "");
  }, [cities, districts, setValue, fetchReceiverDistricts]);

  // ── Map click / drag handler ──────────────────────────────────────────────
  const handleMapPick = useCallback(async (latLng: { lat: number; lng: number }, mapData: any) => {
    // ── INSTANT: pin drops exactly where the user clicked, no waiting ─────
    setPinPosition(latLng);
    setSnappedPosition(null);
    setValue("receiver.latitude", latLng.lat.toString());
    setValue("receiver.longitude", latLng.lng.toString());

    // Detect country from Nominatim & update dropdown if changed
    let activeCountryCode = countryCode;
    const detectedCode = mapData?.address?.country_code?.toUpperCase();
    if (detectedCode && detectedCode !== countryCode && GULF_COUNTRIES.some(c => c.code === detectedCode)) {
      activeCountryCode = detectedCode;
      const gulfName = GULF_COUNTRIES.find(c => c.code === detectedCode)?.name || "";
      const matched = countries.find((c: any) => c.name.toLowerCase() === gulfName.toLowerCase());
      if (matched && onCountryChange) onCountryChange(matched.id);
    }

    if (activeCountryCode === "SA") {
      setShortAddressLoading(true);
      setShortAddressError("");
      setShortAddressWarning("");
      setValue("receiver.shortAddress", "");
      setValue("receiver.nationalAddress", "");
      clearErrors("receiver.shortAddress");
      clearErrors("receiver.nationalAddress");

      // 1. Check if google map (Nominatim) data contains short address
      let foundShortAddress: string | null = null;
      if (mapData) {
        const textToSearch = JSON.stringify(mapData);
        const match = textToSearch.match(/\b([a-zA-Z]{4}\d{4})\b/);
        if (match) {
          foundShortAddress = match[1].toUpperCase();
        }
      }

      if (foundShortAddress) {
        setValue("receiver.shortAddress", foundShortAddress);
        setValue("receiver.nationalAddress", foundShortAddress);

        try {
          const checkRes = await fetch(`${API_BASE}/adrress-get-by-short-address?shortAddress=${foundShortAddress}`);
          const checkData = await checkRes.json();
          if (checkData?.success && checkData?.data) {
            const shortAddr = checkData.data;
            applyAddressFromApi(shortAddr, activeCountryCode);

            if (shortAddr.latitude && shortAddr.longitude) {
              const pos = { lat: parseFloat(shortAddr.latitude), lng: parseFloat(shortAddr.longitude) };
              setPinPosition(pos);
              setSnappedPosition(pos);
              setValue("receiver.latitude", shortAddr.latitude.toString());
              setValue("receiver.longitude", shortAddr.longitude.toString());
            }
            setShortAddressWarning("");
            setShortAddressError("");
            setIsShortAddressLocked(true); // LOCK after success
          } else {
            setShortAddressError("Short Address verified lookup failed. Please type it manually.");
          }
        } catch (err) {
          console.error("Short address verification lookup failed:", err);
          setShortAddressError("Could not verify short address. Please try again.");
        } finally {
          setShortAddressLoading(false);
        }
        isPinnedRef.current = true;
        return;
      }

      // 2. Check coordinates API
      try {
        const res = await fetch(`${API_BASE}/find-by-coordinates?lat=${latLng.lat}&lon=${latLng.lng}`);
        const apiData = await res.json();

        if (apiData?.success && apiData?.data) {
          const addr = apiData.data;
          const source: string = addr.source ?? "database";
          applyAddressFromApi(addr, activeCountryCode);

          if (source === "redis_geo" || source === "database_zone") {
            if (addr.latitude && addr.longitude) {
              const snapped = { lat: parseFloat(addr.latitude), lng: parseFloat(addr.longitude) };
              setSnappedPosition(snapped);
              setPinPosition(snapped);
              setValue("receiver.latitude", addr.latitude.toString());
              setValue("receiver.longitude", addr.longitude.toString());
            }
          }

          const resolvedShortCode = addr.name;
          if (resolvedShortCode) {
            setValue("receiver.shortAddress", resolvedShortCode);
            setValue("receiver.nationalAddress", resolvedShortCode);

            try {
              const checkRes = await fetch(`${API_BASE}/adrress-get-by-short-address?shortAddress=${resolvedShortCode}`);
              const checkData = await checkRes.json();
              if (checkData?.success && checkData?.data) {
                const shortAddr = checkData.data;
                applyAddressFromApi(shortAddr, activeCountryCode);

                if (shortAddr.latitude && shortAddr.longitude) {
                  const pos = { lat: parseFloat(shortAddr.latitude), lng: parseFloat(shortAddr.longitude) };
                  setPinPosition(pos);
                  setSnappedPosition(pos);
                  setValue("receiver.latitude", shortAddr.latitude.toString());
                  setValue("receiver.longitude", shortAddr.longitude.toString());
                }

                if (source === "database_zone") {
                  setShortAddressWarning("📍 Approximate match. Pin again on the exact spot for precise short address.");
                } else {
                  setShortAddressWarning("");
                }
                setShortAddressError("");
                setIsShortAddressLocked(true); // LOCK after success
              } else {
                setShortAddressError("Short Address verified lookup failed. Please type it manually.");
              }
            } catch (err) {
              console.error("Short address verification lookup failed:", err);
              setShortAddressError("Could not verify short address. Please try again.");
            }
          } else {
            setValue("receiver.shortAddress", "");
            setValue("receiver.nationalAddress", "");
            setShortAddressError("Short Address was not found from the map. Please fill it manually.");
          }

          isPinnedRef.current = true;
          setShortAddressLoading(false);
          return;
        }
      } catch (err) {
        console.error("find-by-coordinates failed:", err);
      }

      // 3. Fallback: geocoding but no short address found
      setShortAddressLoading(false);
      setValue("receiver.shortAddress", "");
      setValue("receiver.nationalAddress", "");
      setShortAddressWarning("");
      setShortAddressError("Short Address was not found from the map. Please fill it manually.");
    }

    const parsed: any = parseNominatimResult(mapData, activeCountryCode);
    setValue("receiver.address", parsed.fullAddress || "");

    if (parsed.city) {
      setValue("receiver.cityName", parsed.city);
      const cityData = cities?.find((c: any) => c.name.toLowerCase() === parsed.city.toLowerCase());
      setValue("receiver.city", cityData?.id ?? null as any);
      if (cityData) fetchReceiverDistricts();
    }

    const districtEquivalent = parsed.district || parsed.area || parsed.zone || parsed.block || parsed.wilayat;
    if (districtEquivalent) {
      setValue("receiver.districtName", districtEquivalent);
      const distData = districts?.find((d: any) => d.name.toLowerCase() === districtEquivalent.toLowerCase());
      setValue("receiver.district", distData?.id ?? null as any);
      clearErrors("receiver.district");
    }

    setValue("receiver.streetName", parsed.street || "");
    setValue("receiver.buildingNumber", parsed.building || "");
    setValue("receiver.zipCode", parsed.postalCode || parsed.poBox || "");

    if (activeCountryCode !== "SA" && parsed.shortAddress) {
      setValue("receiver.shortAddress", parsed.shortAddress);
      setValue("receiver.nationalAddress", parsed.shortAddress);
    }

    isPinnedRef.current = true;
  }, [countryCode, countries, onCountryChange, setValue, applyAddressFromApi, cities, districts, fetchReceiverDistricts, clearErrors]);

  // ── Short address manual input ────────────────────────────────────────────
  const handleShortAddressChange = useCallback(async (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value.toUpperCase();
    setValue("receiver.shortAddress", val);
    setValue("receiver.nationalAddress", val);
    setShortAddressWarning("");
    setShortAddressError("");
    clearErrors("receiver.shortAddress");
    clearErrors("receiver.nationalAddress");

    if (val.length === 8) {
      setShortAddressLoading(true);
      try {
        const res = await fetch(`${API_BASE}/adrress-get-by-short-address?shortAddress=${val}`);
        const apiData = await res.json();
        if (apiData?.success && apiData?.data) {
          const addr = apiData.data;
          setShortAddressError("");
          applyAddressFromApi(addr, countryCode);

          if (addr.latitude && addr.longitude) {
            const pos = { lat: parseFloat(addr.latitude), lng: parseFloat(addr.longitude) };
            setPinPosition(pos);
            setSnappedPosition(pos);
            setValue("receiver.latitude", addr.latitude.toString());
            setValue("receiver.longitude", addr.longitude.toString());
          }
          clearErrors("receiver.shortAddress");
          clearErrors("receiver.nationalAddress");
          setIsShortAddressLocked(true); // LOCK after success
        } else {
          setShortAddressError("Short code not found. Please check and enter a correct code.");
          setIsShortAddressLocked(false);
        }
      } catch (err) {
        console.error("Short address lookup failed:", err);
        setShortAddressError("Could not verify short address. Please try again.");
        setIsShortAddressLocked(false);
      } finally {
        setShortAddressLoading(false);
      }
    } else {
      // Not 8 chars → unlock if it was locked
      setIsShortAddressLocked(false);
      if (val.length === 0) {
        setPinPosition(null);
        setSnappedPosition(null);
      }
    }
  }, [setValue, countryCode, applyAddressFromApi, clearErrors]);

  // Reset pin tracking when map is re-opened
  const handleToggleMap = useCallback(() => {
    setShowMap(prev => {
      if (!prev) isPinnedRef.current = false; // fresh open → reset
      return !prev;
    });
  }, []);

  const fieldKeys: string[] = useMemo(() => COUNTRY_FIELDS[countryCode] || COUNTRY_FIELDS["SA"], [countryCode]);

  const isPinned = !!pinPosition;
  const shortAddressVal = watch("receiver.shortAddress");
  const shortAddressOk = !shortAddressLoading && !shortAddressError && shortAddressVal?.length === 8 && watch("receiver.address");

  // const compactInputCls = (hasErr?: boolean) =>
  //   `w-full text-sm rounded-lg border px-3 py-1.5 outline-none focus:border-[#FBD037] focus:ring-1 focus:ring-[#FBD037]/30 transition-all ${hasErr ? "border-red-400 bg-red-50" : "border-gray-200 bg-white"}`;

  const compactInputCls = ({ hasErr = false, disabled = false }: { hasErr?: boolean; disabled?: boolean }) => {
  let base = "w-full text-sm rounded-lg border px-3 py-1.5 outline-none transition-all";
  if (disabled) {
    base += " bg-gray-100 text-gray-500 cursor-not-allowed opacity-70 border-gray-200";
  } else if (hasErr) {
    base += " border-red-400 bg-red-50 focus:border-[#FBD037] focus:ring-1 focus:ring-[#FBD037]/30";
  } else {
    base += " border-gray-200 bg-white focus:border-[#FBD037] focus:ring-1 focus:ring-[#FBD037]/30";
  }
  return base;
};

  const gridFields = useMemo(() => {
    if (countryCode === "SA") {
      return ["shortAddress", "city", "district", "street", "latitude", "longitude", "building", "postalCode"];
    } else {
      const keys = fieldKeys.filter(k => k !== "shortAddress");
      const first4 = keys.slice(0, 4);
      const remaining = keys.slice(4);
      return [...first4, "latitude", "longitude", ...remaining];
    }
  }, [countryCode, fieldKeys]);

  const renderField = (key: string) => {
    if (key === "shortAddress") {
      return (
        <StackedRow key={key} label={t("Short Add")} required={countryCode === "SA"}>
          <div className="relative">
            <input
              {...(() => {
                const { onChange: formOnChange, ...rest } = register("receiver.shortAddress", {
                  required: countryCode === "SA" ? t("Short address is required") : false,
                  validate: (val) => {
                    if (countryCode === "SA" && val && val.length !== 8) {
                      return t("Short address must be 8 characters");
                    }
                    return true;
                  }
                });
                return { ...rest, onChange: (e: any) => { formOnChange(e); handleShortAddressChange(e); } };
              })()}
              placeholder={t("e.g. RHOO2375")}
              autoComplete="off"
              disabled={shortAddressLoading}
              className={`w-full text-sm rounded-lg border px-3 py-1.5 outline-none pr-8 transition-all focus:border-[#FBD037] ${
                shortAddressLoading ? "border-blue-300 bg-blue-50" : (shortAddressError || errors.receiver?.shortAddress) ? "border-red-400 bg-red-50" : shortAddressWarning ? "border-yellow-400 bg-white" : "border-gray-200 bg-white"
              }`}
            />
            <div className="absolute inset-y-0 right-2 flex items-center">
              {shortAddressLoading && <Spinner />}
              {!shortAddressLoading && (shortAddressError || errors.receiver?.shortAddress) && <span className="text-red-500 text-sm">✕</span>}
              {shortAddressOk && <span className="text-green-500 text-sm">✓</span>}
            </div>
          </div>
          {shortAddressError && !shortAddressLoading && <p className="text-[10px] text-red-500 mt-0.5">⚠ {t(shortAddressError)}</p>}
          {errors.receiver?.shortAddress && !shortAddressError && !shortAddressLoading && (
            <p className="text-[10px] text-red-500 mt-0.5">⚠ {t(errors.receiver?.shortAddress?.message || "")}</p>
          )}
          {shortAddressWarning && !shortAddressError && !errors.receiver?.shortAddress && !shortAddressLoading && <p className="text-[10px] text-yellow-600 mt-0.5">{t(shortAddressWarning)}</p>}
        </StackedRow>
      );
    }

    const isCity = key === "city";
    const isDistrict = ["district", "area", "zone", "block", "wilayat", "governorate"].includes(key);
    let rhfName: any = `receiver.${key}`;
    if (key === "street" || key === "road") rhfName = "receiver.streetName";
    if (key === "building") rhfName = "receiver.buildingNumber";
    if (key === "poBox" || key === "postalCode") rhfName = "receiver.zipCode";
    const isRequiredField = key !== "region" && key !== "poBox" && (countryCode === "SA" || (key !== "street" && key !== "building"));
    const fieldKey = rhfName.replace(/^receiver\./, "");
    const fieldError = (errors.receiver as any)?.[fieldKey];

    if (isCity) return (
      <StackedRow key={key} label={t(FIELD_LABELS[key]?.label || "City / Town")} required>
        <SelectInput name="receiver.city" label="" placeholder={t(FIELD_LABELS[key]?.placeholder || "")}
          selectOptions={cities?.map((c: any) => ({ id: c.id, value: c.id, text: c.name })) || []}
          value={watch("receiver.city") || watch("receiver.cityName")}
          setValue={(val) => {
            const m = cities?.find((c: any) => c.id === val);
            if (m) {
              setValue("receiver.city", m.id);
              setValue("receiver.cityName", m.name);
            } else {
              setValue("receiver.city", null as any);
              setValue("receiver.cityName", val);
            }
          }}
          onSearch={handleCitySearch} isPending={isCitiesFetchPending} register={register}
          validation={{ required: t("City is required") }} error={errors.receiver?.city} clearErrors={clearErrors} allowCustom={true}
          disabled={isShortAddressLocked} // NEW
        />
      </StackedRow>
    );

    if (isDistrict) return (
      <StackedRow key={key} label={t(FIELD_LABELS[key]?.label || "District")} required>
        <SelectInput name="receiver.district" label="" placeholder={t(FIELD_LABELS[key]?.placeholder || "")}
          selectOptions={districts?.map((d: any) => ({ id: d.id, value: d.id, text: d.name })) || []}
          value={watch("receiver.district") || watch("receiver.districtName")}
          setValue={(val) => {
            const m = districts?.find((d: any) => d.id === val);
            if (m) {
              setValue("receiver.district", m.id);
              setValue("receiver.districtName", m.name);
            } else {
              setValue("receiver.district", null as any);
              setValue("receiver.districtName", val);
            }
          }}
          onSearch={handleDistrictSearch} isPending={isDistrictFetchPending} register={register} clearErrors={clearErrors}
          validation={{ validate: (val) => { const dn = watch("receiver.districtName"); return (!val && !dn) ? `${t(FIELD_LABELS[key]?.label || "District")} ${t("is required")}` : true; } }}
          error={errors.receiver?.district} allowCustom={true}
          disabled={isShortAddressLocked} // NEW
        />
      </StackedRow>
    );

    const fieldValidation = rhfName === "receiver.zipCode"
      ? (countryCode === "SA" ? { required: t("Zip code is required"), pattern: { value: /^\d+$/, message: t("Digits only") } } : undefined)
      : isRequiredField ? { required: `${t(FIELD_LABELS[key]?.label || "This field")} ${t("is required")}` } : undefined;

    return (
      <StackedRow key={key} label={t(FIELD_LABELS[key]?.label || key)} required={isRequiredField}>
        <input {...register(rhfName, fieldValidation)} placeholder={t(FIELD_LABELS[key]?.placeholder || "")}
           className={compactInputCls({ hasErr: !!fieldError, disabled: isShortAddressLocked })} /> {/* NEW */}
        {fieldError && <FormErrorMessage error={fieldError} />}
      </StackedRow>
    );
  };

  if (isSidebar) {
    return (
      <div className="w-full mt-1 space-y-3">
        {/* Map toggle compact */}
        <div className="flex items-center justify-between py-1.5 border-b border-slate-100">
          <button type="button" onClick={handleToggleMap}
            className="px-2.5 py-1 rounded-md bg-[#4F6EF7] text-white text-xs font-semibold hover:bg-[#3d59c9] transition-colors">
            {showMap ? t("Hide Map") : t("Open Map")}
          </button>
        </div>

        {showMap && (
          <div className="py-2 border-b border-slate-100">
            <Suspense fallback={<MapSkeleton />}>
              <GulfMapPicker
                country={countryCode}
                onPick={handleMapPick}
                pinPosition={pinPosition}
                snappedPosition={snappedPosition}
                disabled={isShortAddressLocked} // NEW: disable map interactions
              />
            </Suspense>
          </div>
        )}

        {/* Grid for small fields */}
        <div className="grid grid-cols-2 gap-3 relative z-10">
          {gridFields.map((key) => {
            if (key === "latitude") {
              return (
                <StackedRow key="latitude" label={t("Latitude")} required={countryCode === "SA"}>
                  <input {...register("receiver.latitude", countryCode === "SA" ? { required: t("Required") } : undefined)}
                    placeholder={t("e.g. 24.7136")}  className={compactInputCls({ hasErr: !!errors.receiver?.latitude, disabled: isShortAddressLocked })}
                    disabled={isShortAddressLocked} /> {/* NEW */}
                  <FormErrorMessage error={errors.receiver?.latitude} />
                </StackedRow>
              );
            }
            if (key === "longitude") {
              return (
                <StackedRow key="longitude" label={t("Longitude")} required={countryCode === "SA"}>
                  <input {...register("receiver.longitude", countryCode === "SA" ? { required: t("Required") } : undefined)}
                    placeholder={t("e.g. 46.6753")}  className={compactInputCls({ hasErr: !!errors.receiver?.longitude, disabled: isShortAddressLocked })}
                    disabled={isShortAddressLocked} /> {/* NEW */}
                  <FormErrorMessage error={errors.receiver?.longitude} />
                </StackedRow>
              );
            }
            return renderField(key);
          })}
        </div>

        {/* Full Address - large field, full width */}
        <StackedRow label={t("Full Address")} required fullWidth>
          <input
            {...register("receiver.address", { required: t("Full address is required") })}
            placeholder={t("Enter full address")}
            className={compactInputCls({ hasErr: !!errors.receiver?.address, disabled: isShortAddressLocked })}
            disabled={isShortAddressLocked} // NEW
          />
          <FormErrorMessage error={errors.receiver?.address} />
        </StackedRow>
      </div>
    );
  }

  // ── Non-sidebar: original card layout ──
  return (
    <div className={`bg-[#fdfdf6] rounded-xl space-y-6 mt-2 p-4 border w-full ${className}`}>
      <div className="space-y-4">

        {/* Map Toggle */}
        <div className="flex justify-between items-center w-full">
          <label className="text-sm font-medium text-gray-700 flex items-center gap-2">
            {t("Pin Location on Map")}
            {isPinned && <span className="px-2 py-0.5 rounded-full bg-green-100 text-green-700 text-xs font-bold">📍 {t("Pinned")}</span>}
          </label>
          <button
            type="button"
            onClick={handleToggleMap}
            className="px-3 py-1.5 rounded-md bg-[#4F6EF7] text-white text-xs font-semibold hover:bg-[#3d59c9] transition-colors"
          >
            {showMap ? t("Hide Map") : t("Open Map")}
          </button>
        </div>

        {/* The Map — lazy loaded */}
        {showMap && (
          <Suspense fallback={<MapSkeleton />}>
            <GulfMapPicker
              country={countryCode}
              onPick={handleMapPick}
              pinPosition={pinPosition}
              snappedPosition={snappedPosition}
              disabled={isShortAddressLocked} // NEW
            />
          </Suspense>
        )}

        {/* Short Address & Full Address */}
        {countryCode === "SA" ? (
          <div className={`flex gap-4 w-full ${isSidebar ? "flex-col" : "flex-row"}`}>
            <div className={`relative ${isSidebar ? "w-full" : "w-[30%]"}`}>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {t("Short Add / National Address")} <span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <input
                  {...(() => {
                    const { onChange: formOnChange, ...rest } = register("receiver.shortAddress", {
                      required: countryCode === "SA" ? t("Short address is required") : false,
                      validate: (val) => {
                        if (countryCode === "SA" && val && val.length !== 8) {
                          return t("Short address must be 8 characters");
                        }
                        return true;
                      }
                    });
                    return {
                      ...rest,
                      onChange: (e: any) => {
                        formOnChange(e);
                        handleShortAddressChange(e);
                      }
                    };
                  })()}
                  placeholder={t("e.g. RHOO2375")}
                  autoComplete="off"
                  disabled={shortAddressLoading}
                  className={`w-full rounded-lg py-2 px-3 border outline-none pr-9 transition-all
                    ${
                      shortAddressLoading ? "border-blue-300 bg-blue-50" :
                      shortAddressError ? "border-red-400 bg-red-50" :
                      shortAddressWarning ? "border-yellow-500 bg-white" :
                      "border-gray-300 bg-white"
                    } focus:border-[#FBD037]`}
                />
                <div className="absolute inset-y-0 right-2 flex items-center">
                  {shortAddressLoading && <Spinner />}
                  {!shortAddressLoading && shortAddressError && <span className="text-red-500 text-base">✕</span>}
                  {shortAddressOk && <span className="text-green-500 text-base">✓</span>}
                </div>
              </div>
              {shortAddressLoading && (
                <div className="mt-1 flex items-center gap-1.5">
                  <div className="h-2 w-2 rounded-full bg-blue-400 animate-bounce" style={{animationDelay: '0ms'}}/>
                  <div className="h-2 w-2 rounded-full bg-blue-400 animate-bounce" style={{animationDelay: '150ms'}}/>
                  <div className="h-2 w-2 rounded-full bg-blue-400 animate-bounce" style={{animationDelay: '300ms'}}/>
                  <span className="text-xs text-blue-500 font-medium">{t("Looking up address…")}</span>
                </div>
              )}
              {shortAddressError && !shortAddressLoading && (
                <FormErrorMessage error={{ message: `⚠ ${t(shortAddressError)}` }} />
              )}
              {errors.receiver?.shortAddress && !shortAddressError && !shortAddressLoading && (
                <FormErrorMessage error={errors.receiver?.shortAddress} />
              )}
              {shortAddressWarning && !shortAddressError && !shortAddressLoading && (
                <span className="text-xs text-yellow-600 mt-1 block font-medium">{t(shortAddressWarning)}</span>
              )}
            </div>
            <div className={isSidebar ? "w-full" : "w-[70%]"}>
              <label className="block text-sm font-medium text-gray-700 mb-1">{t("Full Address Line")} <span className="text-red-500">*</span></label>
              <input
                {...register("receiver.address", { required: t("Full address is required") })}
                placeholder={t("Enter full address details")}
                className={`w-full rounded-lg py-2 px-3 border outline-none ${
                  errors.receiver?.address ? "border-red-500" : "border-gray-300"
                } focus:border-[#FBD037]`}
                disabled={isShortAddressLocked} // NEW
              />
              <FormErrorMessage error={errors.receiver?.address} />
            </div>
          </div>
        ) : (
          <div className="w-full">
            <label className="block text-sm font-medium text-gray-700 mb-1">{t("Full Address Line")} <span className="text-red-500">*</span></label>
            <input
              {...register("receiver.address", { required: t("Full address is required") })}
              placeholder={t("Enter full address details")}
              className={`w-full rounded-lg py-2 px-3 border outline-none ${
                errors.receiver?.address ? "border-red-500" : "border-gray-300"
              } focus:border-[#FBD037]`}
              disabled={isShortAddressLocked} // NEW
            />
            <FormErrorMessage error={errors.receiver?.address} />
          </div>
        )}

        {/* Latitude & Longitude */}
        <div className={`grid gap-4 ${isSidebar ? "grid-cols-1" : "grid-cols-2"}`}>
          <div className="col-span-1">
            <label className="block text-sm font-medium text-gray-700 mb-1">{t("Latitude")} <span className="text-red-500">*</span></label>
            <input
              {...register("receiver.latitude", countryCode === "SA" ? { required: t("Latitude is required") } : undefined)}
              placeholder={t("e.g. 24.7136")}
              className={`w-full rounded-lg py-2 px-3 border outline-none ${
                errors.receiver?.latitude ? "border-red-500" : "border-gray-300"
              } focus:border-[#FBD037]`}
              disabled={isShortAddressLocked} // NEW
            />
            <FormErrorMessage error={errors.receiver?.latitude} />
          </div>
          <div className="col-span-1">
            <label className="block text-sm font-medium text-gray-700 mb-1">{t("Longitude")} <span className="text-red-500">*</span></label>
            <input
              {...register("receiver.longitude", countryCode === "SA" ? { required: t("Longitude is required") } : undefined)}
              placeholder={t("e.g. 46.6753")}
              className={`w-full rounded-lg py-2 px-3 border outline-none ${
                errors.receiver?.longitude ? "border-red-500" : "border-gray-300"
              } focus:border-[#FBD037]`}
              disabled={isShortAddressLocked} // NEW
            />
            <FormErrorMessage error={errors.receiver?.longitude} />
          </div>
        </div>

        {/* Dynamic Fields */}
        <div className={`grid gap-4 ${isSidebar ? "grid-cols-1" : "grid-cols-2"}`}>
          {fieldKeys.filter(k => k !== "shortAddress").map((key) => {
            const isCity = key === "city";
            const isDistrict = ["district", "area", "zone", "block", "wilayat"].includes(key);

            if (isCity) {
              return (
                <div key={key} className="col-span-1">
                  <SelectInput
                    name="receiver.city"
                    label={t(FIELD_LABELS[key]?.label || "")}
                    placeholder={t(FIELD_LABELS[key]?.placeholder || "")}
                    selectOptions={cities?.map((c: any) => ({
                      id: c.id,
                      value: c.id,
                      text: c.name,
                    })) || []}
                    value={watch("receiver.city") || watch("receiver.cityName")}
                    setValue={(val) => {
                      const matched = cities?.find((c: any) => c.id === val);
                      if (matched) {
                        setValue("receiver.city", matched.id);
                        setValue("receiver.cityName", matched.name);
                      } else {
                        setValue("receiver.city", null as any);
                        setValue("receiver.cityName", val);
                      }
                    }}
                    onSearch={handleCitySearch}
                    isPending={isCitiesFetchPending}
                    register={register}
                    validation={{ required: t("City is required") }}
                    error={errors.receiver?.city}
                    clearErrors={clearErrors}
                    allowCustom={true}
                    disabled={isShortAddressLocked} // NEW
                  />
                </div>
              );
            }

            if (isDistrict) {
              return (
                <div key={key} className="col-span-1">
                  <SelectInput
                    name="receiver.district"
                    label={t(FIELD_LABELS[key]?.label || "")}
                    placeholder={t(FIELD_LABELS[key]?.placeholder || "")}
                    selectOptions={districts?.map((d: any) => ({
                      id: d.id,
                      value: d.id,
                      text: d.name,
                    })) || []}
                    value={watch("receiver.district") || watch("receiver.districtName")}
                    setValue={(val) => {
                      const matched = districts?.find((d: any) => d.id === val);
                      if (matched) {
                        setValue("receiver.district", matched.id);
                        setValue("receiver.districtName", matched.name);
                      } else {
                        setValue("receiver.district", null as any);
                        setValue("receiver.districtName", val);
                      }
                    }}
                    onSearch={handleDistrictSearch}
                    isPending={isDistrictFetchPending}
                    register={register}
                    clearErrors={clearErrors}
                    validation={{
                      validate: (val) => {
                        const districtName = watch("receiver.districtName");
                        if (!val && !districtName) {
                          return `${t(FIELD_LABELS[key]?.label || "District")} ${t("is required")}`;
                        }
                        return true;
                      }
                    }}
                    error={errors.receiver?.district}
                    allowCustom={true}
                    disabled={isShortAddressLocked} // NEW
                  />
                </div>
              );
            }

            // Other dynamic fields
            let rhfName: any = `receiver.${key}`;
            if (key === "street" || key === "road") rhfName = "receiver.streetName";
            if (key === "building") rhfName = "receiver.buildingNumber";
            if (key === "poBox" || key === "postalCode") rhfName = "receiver.zipCode";

            const isRequiredField = key !== "region" && key !== "poBox" && (countryCode === "SA" || (key !== "street" && key !== "building"));
            const fieldValidation = rhfName === "receiver.zipCode"
              ? (countryCode === "SA"
                ? {
                    required: t("Zip code is required"),
                    pattern: {
                      value: /^\d+$/,
                      message: t("Zip code must contain only digits"),
                    },
                  }
                : undefined
              )
              : isRequiredField
              ? { required: `${t(FIELD_LABELS[key]?.label || "This field")} ${t("is required")}` }
              : undefined;

            const fieldKey = rhfName.replace(/^receiver\./, "");
            const fieldError = (errors.receiver as any)?.[fieldKey];

            return (
              <div key={key} className="col-span-1">
                <label className="block text-sm font-medium text-gray-700 mb-1">{t(FIELD_LABELS[key]?.label || key)}</label>
                <input
                  {...register(rhfName, fieldValidation)}
                  placeholder={t(FIELD_LABELS[key]?.placeholder || "")}
                  className={`w-full rounded-lg py-2 px-3 border outline-none focus:border-[#FBD037] ${
                    fieldError ? "border-red-500" : "border-gray-300"
                  }`}
                  disabled={isShortAddressLocked} // NEW
                />
                {fieldError && <FormErrorMessage error={fieldError} />}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default memo(ReceiverAddress);